(function() {
  function bindCartForm(form) {
    if (form.dataset.ajaxCartBound === '1') return;
    form.dataset.ajaxCartBound = '1';
    var input = form.querySelector('.product__quantity-input');
    var minusBtn = form.querySelector('.product__quantity-btn--minus');
    var plusBtn = form.querySelector('.product__quantity-btn--plus');
    function setQuantity(val) {
      if (!input) return;
      input.value = String(val);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (input && minusBtn) {
      minusBtn.addEventListener('click', function() {
        var val = parseInt(input.value, 10) || 1;
        if (val > 1) setQuantity(val - 1);
      });
    }
    if (input && plusBtn) {
      plusBtn.addEventListener('click', function() {
        var val = parseInt(input.value, 10) || 0;
        if (val < 99) setQuantity(val + 1);
      });
    }

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var submitBtn = form.querySelector('button[name="add"][type="submit"]');
      var btnText = form.querySelector('.product__add-btn-text, .product-card__add-btn-text');
      if (submitBtn && submitBtn.disabled) return;
      var addingText = form.dataset.addingText || 'Ekleniyor...';
      var normalText = btnText ? btnText.textContent : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-busy', 'true');
      }
      if (btnText) btnText.textContent = addingText;
      form.dispatchEvent(new CustomEvent('product:atc-busy', { bubbles: true, detail: { busy: true, addingText: addingText } }));
      var actionUrl = form.action;
      if (actionUrl.indexOf('.js') === -1) {
        actionUrl = actionUrl.split('?')[0] + '.js';
      }

      fetch(actionUrl, {
        method: 'POST',
        body: new FormData(form),
        headers: {
          'Accept': 'application/json'
        }
      }).then(function(res) {
        return res.json().then(function(json) {
          if (!res.ok) {
            throw new Error(json.description || json.message || 'Add to cart failed');
          }
          return json;
        });
      }).then(function() {
        try {
          if (typeof window.__DL_trackAddToCart === 'function') {
            var qtyInput = form.querySelector('.product__quantity-input');
            var qty = qtyInput ? qtyInput.value : '1';
            window.__DL_trackAddToCart(form, qty);
          }
        } catch (eDl) {}
        if (typeof window.openCartDrawer === 'function') {
          window.openCartDrawer();
        } else {
          var notification = document.getElementById('cart-notification');
          if (notification) {
            var img = document.getElementById('cart-notification-image');
            var titleEl = document.getElementById('cart-notification-title');
            var variantEl = document.getElementById('cart-notification-variant');
            if (img) {
              if (form.dataset.productImage) {
                img.src = form.dataset.productImage;
                img.style.display = '';
              } else {
                img.style.display = 'none';
              }
            }
            if (titleEl) titleEl.textContent = form.dataset.productTitle || '';
            if (variantEl) {
              var qtyInput = form.querySelector('.product__quantity-input');
              var qty = qtyInput ? qtyInput.value : '1';
              variantEl.textContent = qty + ' adet';
              variantEl.style.display = '';
            }
            notification.setAttribute('aria-hidden', 'false');
          }
        }
        var countEl = document.getElementById('cart-count');
        var countMobile = document.getElementById('cart-count-mobile');
        var mobileCartLink = document.getElementById('header-mobile-cart-link');
        if (countEl || countMobile || mobileCartLink) {
          fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
            var n = cart.item_count || 0;
            if (countEl) countEl.textContent = n;
            if (countMobile) {
              countMobile.textContent = n;
              countMobile.classList.toggle('header__cart-badge--zero', n === 0);
            }
            if (mobileCartLink) {
              mobileCartLink.setAttribute('aria-label', 'Sepet (' + n + ' ürün)');
              mobileCartLink.setAttribute('title', 'Sepet (' + n + ' ürün)');
            }
          }).catch(function() {});
        }
      }).catch(function() {
        // Error handled silently
        var fallbackUrl = form.action.replace('.js', '');
        window.location.href = fallbackUrl + '?' + new URLSearchParams(new FormData(form)).toString();
      }).finally(function() {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.removeAttribute('aria-busy');
        }
        if (btnText) btnText.textContent = normalText;
        form.dispatchEvent(new CustomEvent('product:atc-busy', { bubbles: true, detail: { busy: false, normalText: normalText } }));
      });
    });
  }

  function bindAllAjaxCartForms(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('form[data-ajax-cart]').forEach(bindCartForm);
  }

  bindAllAjaxCartForms(document);

  function bindLookcareSetBundle(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var raw = form.getAttribute('data-items-json');
      if (!raw) return;
      var items;
      try {
        items = JSON.parse(raw);
      } catch (err) {
        return;
      }
      if (!items || !items.length) return;

      var btn = form.querySelector('button[type="submit"]');
      var txt = form.querySelector('.lookcare-sets__add-text');
      var addingText = form.dataset.addingText || 'Ekleniyor...';
      var normalText = txt ? txt.textContent : '';
      if (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
      }
      if (txt) txt.textContent = addingText;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: items })
      })
        .then(function(res) {
          if (!res.ok) throw new Error('add');
          return res.json();
        })
        .then(function(added) {
          try {
            if (typeof window.__DL_trackAddToCartBundle === 'function') {
              window.__DL_trackAddToCartBundle(added, items);
            }
          } catch (eDl) {}
          if (typeof window.openCartDrawer === 'function') {
            window.openCartDrawer();
          } else {
            var notification = document.getElementById('cart-notification');
            var titleEl = document.getElementById('cart-notification-title');
            var img = document.getElementById('cart-notification-image');
            var variantEl = document.getElementById('cart-notification-variant');
            if (titleEl) titleEl.textContent = form.getAttribute('data-product-title') || '';
            if (variantEl) {
              variantEl.textContent = items.length + ' ürün';
              variantEl.style.display = '';
            }
            if (img && form.getAttribute('data-product-image')) {
              img.src = form.getAttribute('data-product-image');
              img.style.display = '';
            } else if (img) {
              img.style.display = 'none';
            }
            if (notification) notification.setAttribute('aria-hidden', 'false');
          }
          var countEl = document.getElementById('cart-count');
          var countMobile = document.getElementById('cart-count-mobile');
          var mobileCartLink = document.getElementById('header-mobile-cart-link');
          if (countEl || countMobile || mobileCartLink) {
            fetch('/cart.js')
              .then(function(r) {
                return r.json();
              })
              .then(function(cart) {
                var n = cart.item_count || 0;
                if (countEl) countEl.textContent = n;
                if (countMobile) {
                  countMobile.textContent = n;
                  countMobile.classList.toggle('header__cart-badge--zero', n === 0);
                }
                if (mobileCartLink) {
                  mobileCartLink.setAttribute('aria-label', 'Sepet (' + n + ' ürün)');
                  mobileCartLink.setAttribute('title', 'Sepet (' + n + ' ürün)');
                }
              })
              .catch(function() {});
          }
        })
        .catch(function() {
          // Error handled silently
          window.location.href = '/cart';
        })
        .finally(function() {
          if (btn) {
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
          }
          if (txt) txt.textContent = normalText;
        });
    });
  }

  function bindAllLookcareSetBundles(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('form[data-lookcare-set-bundle]').forEach(function(form) {
      if (form.dataset.lookcareSetBundleBound === '1') return;
      form.dataset.lookcareSetBundleBound = '1';
      bindLookcareSetBundle(form);
    });
  }

  bindAllLookcareSetBundles(document);

  document.addEventListener('shopify:section:load', function(e) {
    var t = e.target;
    if (!t || !t.querySelectorAll) return;
    if (t.querySelector('form[data-ajax-cart]')) {
      bindAllAjaxCartForms(t);
    }
    if (t.querySelector('form[data-lookcare-set-bundle]')) {
      bindAllLookcareSetBundles(t);
    }
  });

  document.addEventListener('click', function(e) {
    var closeBtn = document.getElementById('cart-notification-close');
    if (closeBtn && (e.target === closeBtn || closeBtn.contains(e.target))) {
      var notification = document.getElementById('cart-notification');
      if (notification) notification.setAttribute('aria-hidden', 'true');
    }
  });
})();
